import { platformClient } from '../../platform/client/platform-client';
import {
  ENDPOINTS,
} from '../../api/endpoints';
import {
  FeedResponse,
  PulsePost,
  PulseFeedItem,
  CreatePostDto,
  UpdatePostDto,
  AddReactionDto,
  CreateCommentDto,
  PulseApiResponse,
} from './pulse.types';

export class PulseService {
  static async getFeed(
    params: {
      organizationId?: string;
      cursor?: string;
      limit?: number;
      sourceModule?: string;
      sourceEntityType?: string;
      type?: string;
      search?: string;
      from?: string;
      to?: string;
    } = {}
  ): Promise<FeedResponse> {
    const response = await platformClient.get(
      ENDPOINTS.PULSE.FEED,
      {
        params: {
          cursor: params.cursor,
          limit: params.limit,
          sourceModule: params.sourceModule,
          sourceEntityType: params.sourceEntityType,
          type: params.type,
          search: params.search,
          from: params.from,
          to: params.to,
        },
      }
    );
    const data = (response as PulseApiResponse<FeedResponse>).data;
    return {
      items: data.items || [],
      nextCursor: data.nextCursor || null,
      hasMore: data.hasMore || false,
    };
  }

  static async createPost(
    organizationId: string,
    authorId: string,
    dto: CreatePostDto
  ): Promise<PulsePost> {
    const response = await platformClient.post(
      ENDPOINTS.PULSE.POSTS,
      dto
    );
    return (response as PulseApiResponse<PulsePost>).data;
  }

  static async getPost(
    organizationId: string,
    postId: string
  ): Promise<PulsePost> {
    const response = await platformClient.get(
      ENDPOINTS.PULSE.POST_BY_ID(postId)
    );
    return (response as PulseApiResponse<PulsePost>).data;
  }

  static async updatePost(
    organizationId: string,
    postId: string,
    userId: string,
    dto: UpdatePostDto
  ): Promise<PulsePost> {
    const response = await platformClient.patch(
      ENDPOINTS.PULSE.POST_BY_ID(postId),
      dto
    );
    return (response as PulseApiResponse<PulsePost>).data;
  }

  static async deletePost(
    organizationId: string,
    postId: string,
    userId: string
  ): Promise<{ success: boolean }> {
    const response = await platformClient.delete(
      ENDPOINTS.PULSE.POST_BY_ID(postId)
    );
    return (response as PulseApiResponse<{ success: boolean }>).data;
  }

  static async addReaction(
    organizationId: string,
    postId: string,
    userId: string,
    dto: AddReactionDto
  ): Promise<unknown> {
    const response = await platformClient.post(
      ENDPOINTS.PULSE.REACTIONS(postId),
      dto
    );
    return (response as PulseApiResponse<unknown>).data;
  }

  static async removeReaction(
    organizationId: string,
    postId: string,
    userId: string,
    dto: AddReactionDto
  ): Promise<{ success: boolean }> {
    const response = await platformClient.delete(
      ENDPOINTS.PULSE.REACTIONS(postId),
      {
      data: {
          ...dto,
        },
      }
    );
    return (response as PulseApiResponse<{ success: boolean }>).data;
  }

  static async createComment(
    organizationId: string,
    postId: string,
    userId: string,
    dto: CreateCommentDto
  ): Promise<unknown> {
    const response = await platformClient.post(
      ENDPOINTS.PULSE.COMMENTS(postId),
      dto
    );
    return (response as PulseApiResponse<unknown>).data;
  }

  static async getComments(
    organizationId: string,
    postId: string,
    cursor?: string,
    limit: number = 20
  ): Promise<FeedResponse> {
    const response = await platformClient.get(
      ENDPOINTS.PULSE.COMMENTS(postId),
      {
        params: {
          cursor,
          limit,
          organizationId,
        },
      }
    );
    const data = (response as PulseApiResponse<FeedResponse>).data;
    return {
      items: data.items || [],
      nextCursor: data.nextCursor || null,
      hasMore: data.hasMore || false,
    };
  }
}
